module.exports = __webpack_public_path__ + "img/sb03.98d5fa87.png";